import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-gray-100 pb-12 pt-6"
}
const _hoisted_2 = { class: "container mx-auto px-4 max-w-5xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "font-bold text-gray-800 mb-0 text-2xl text-center pt-5" }, " ACREDITARME ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-800 mb-4 text-2xl text-center pt-2 pb-5" }, " Por favor complete el formulario en su totalidad ", -1)
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_6 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_13 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Email", -1)
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Reingrese su email", -1)
const _hoisted_22 = { class: "text-sm text-red-500 p-error" }
const _hoisted_23 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_24 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Empresa", -1)
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Cargo", -1)
const _hoisted_29 = { class: "text-sm text-red-500 p-error" }
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_31 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Web Site", -1)
const _hoisted_33 = { class: "text-sm text-red-500 p-error" }
const _hoisted_34 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_35 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Pais", -1)
const _hoisted_37 = { class: "text-sm text-red-500 p-error" }
const _hoisted_38 = {
  key: 0,
  class: "w-full px-2 md:w-1/3"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)
const _hoisted_40 = { class: "text-sm text-red-500 p-error" }
const _hoisted_41 = { class: "w-full px-2 md:w-1/3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Localidad", -1)
const _hoisted_43 = { class: "text-sm text-red-500 p-error" }
const _hoisted_44 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_45 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de país", -1)
const _hoisted_47 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Código de área", -1)
const _hoisted_49 = { class: "text-sm text-red-500 p-error" }
const _hoisted_50 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Teléfono celular", -1)
const _hoisted_52 = { class: "text-sm text-red-500 p-error" }
const _hoisted_53 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_54 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Instagram", -1)
const _hoisted_56 = { class: "text-sm text-red-500 p-error" }
const _hoisted_57 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "¿Alguna vez participó en CAPER Show ?", -1)
const _hoisted_59 = { class: "text-sm text-red-500 p-error" }
const _hoisted_60 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_61 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Seleccione el ítem que mejor describa la actividad principal de su Empresa/Organización", -1)
const _hoisted_63 = { class: "text-sm text-red-500 p-error" }
const _hoisted_64 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_65 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Especifique la actividad", -1)
const _hoisted_67 = { class: "text-sm text-red-500 p-error" }
const _hoisted_68 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_69 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Indique en qué área se desempeña dentro de su Empresa / Organización ", -1)
const _hoisted_71 = { class: "text-sm text-red-500 p-error" }
const _hoisted_72 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_73 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Especifique el área", -1)
const _hoisted_75 = { class: "text-sm text-red-500 p-error" }
const _hoisted_76 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_77 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Indique cuál es su Cargo/Rol dentro de la Empresa u Organización", -1)
const _hoisted_79 = { class: "flex flex-col align-items-center" }
const _hoisted_80 = { class: "text-xs text-wrap" }
const _hoisted_81 = { class: "text-sm text-red-500 p-error" }
const _hoisted_82 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_83 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Especifique el Cargo/Rol", -1)
const _hoisted_85 = { class: "text-sm text-red-500 p-error" }
const _hoisted_86 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_87 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-1" }, "Especifique su rol en la compra", -1)
const _hoisted_89 = { class: "text-sm text-red-500 p-error" }
const _hoisted_90 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_91 = { class: "pt-2 pb-2 px-2" }
const _hoisted_92 = { class: "flex items-center" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", {
  for: "aggrement",
  class: "text-gray-600 ml-3 cursor-pointer"
}, "Ya leí y estoy de acuerdo con los términos y condiciones", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "pb-2 text-justify text-xs max-h-96 px-2" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createTextVNode("Dejo constancia que he leído, comprendido y aceptado todos los términos de la presente inscripción. Asimismo, acepto que CAPER puede utilizar y/o divulgar la información y/o datos aquí consignados (a excepción de DNI / PASAPORTE), así como las imágenes y videos que se tomen en el marco del evento, con el fin de difundirlos entre las empresas Expositoras y/o Sponsors y/o Prensa, para su conocimiento y aplicación pertinente. CAPER Show ofrece a los visitantes un servicio de traslado sin cargo tipo charter durante los tres días del evento con circuito entre Plaza Italia y el Centro Costa Salguero, según detalle de horarios que se informa en la página web de CAPER. Teniendo otras vías de transporte alternativas, CAPER no se responsabiliza por cualquier demora, impedimento o daño generado por el servicio de charter antes indicado."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" Por razones de seguridad, los Visitantes aceptan ser fotografiados / filmados en el acceso así como a presentar sus DNIs físicos al momento de retirar su credencial."),
      /*#__PURE__*/_createElementVNode("br")
    ])
  ])
], -1)
const _hoisted_95 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_96 = ["disabled"]
const _hoisted_97 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_98 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Nombre",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}],
                      readonly: _ctx.soloLectura 
                    }), null, 16, ["class", "readonly"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Apellido",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}],
                      readonly: _ctx.soloLectura 
                    }), null, 16, ["class", "readonly"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "numeric",
                      placeholder: "Documento / Pasaporte",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Email",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}],
                      readonly: _ctx.soloLectura 
                    }), null, 16, ["class", "readonly"]),
                    _createElementVNode("span", _hoisted_19, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_Field, {
                  name: "mailConfirmacion",
                  modelValue: _ctx.formData.mailConfirmacion,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.mailConfirmacion) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Reingrese su email",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_ErrorMessage, { name: "mailConfirmacion" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Empresa",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_26, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Field, {
                  name: "cargo",
                  modelValue: _ctx.formData.cargo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.cargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Cargo",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_ErrorMessage, { name: "cargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_Field, {
                  name: "website",
                  modelValue: _ctx.formData.website,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.website) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Web site",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_33, [
                      _createVNode(_component_ErrorMessage, { name: "website" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_Field, {
                  name: "pais",
                  modelValue: _ctx.formData.pais,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.pais) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione el pais",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.paises,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_37, [
                      _createVNode(_component_ErrorMessage, { name: "pais" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.formData.pais.id == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode(_component_Field, {
                      name: "provincia",
                      modelValue: _ctx.formData.provincia,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.provincia) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                        _createVNode(_component_Dropdown, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: "Seleccione la provincia",
                          class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                          options: _ctx.provincias,
                          optionLabel: "descripcion"
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                        _createElementVNode("span", _hoisted_40, [
                          _createVNode(_component_ErrorMessage, { name: "provincia" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _createVNode(_component_Field, {
                  name: "localidad",
                  modelValue: _ctx.formData.localidad,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.localidad) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese la localidad",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_43, [
                      _createVNode(_component_ErrorMessage, { name: "localidad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                (_ctx.formData.pais !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.formData.pais.id,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.pais.id) = $event)),
                      class: "w-full p-inputtext-sm p-3",
                      disabled: "true"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _createVNode(_component_Field, {
                  name: "codigoAreaCel",
                  modelValue: _ctx.formData.codigoAreaCel,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.codigoAreaCel) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Codigo de area sin 0 delante",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_49, [
                      _createVNode(_component_ErrorMessage, { name: "codigoAreaCel" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_Field, {
                  name: "telefonoCelular",
                  modelValue: _ctx.formData.telefonoCelular,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Número de celular sin el 15 delante",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_52, [
                      _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createVNode(_component_Field, {
                  name: "instagram",
                  modelValue: _ctx.formData.instagram,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.instagram) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Ingrese su instagram (Opcional)",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_56, [
                      _createVNode(_component_ErrorMessage, { name: "instagram" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _createVNode(_component_Field, {
                  name: "participo",
                  modelValue: _ctx.formData.participo,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.participo) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.opcionesSiNo,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_59, [
                      _createVNode(_component_ErrorMessage, { name: "participo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _createVNode(_component_Field, {
                  name: "actividadPrincipal",
                  modelValue: _ctx.formData.actividadPrincipal,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.actividadPrincipal) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.actividades,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_63, [
                      _createVNode(_component_ErrorMessage, { name: "actividadPrincipal" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode(_component_Field, {
                  name: "otraActividad",
                  modelValue: _ctx.formData.otraActividad,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.otraActividad) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Otra actividad",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_67, [
                      _createVNode(_component_ErrorMessage, { name: "otraActividad" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.actividadPrincipal?.id === 'Otros (por favor, especifique)']
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _hoisted_70,
                _createVNode(_component_Field, {
                  name: "areaDentroDeLaEmpresa",
                  modelValue: _ctx.formData.areaDentroDeLaEmpresa,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.areaDentroDeLaEmpresa) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.areasEmpresa,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_71, [
                      _createVNode(_component_ErrorMessage, { name: "areaDentroDeLaEmpresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, [
                _hoisted_74,
                _createVNode(_component_Field, {
                  name: "otraArea",
                  modelValue: _ctx.formData.otraArea,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.otraArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Otra área",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_75, [
                      _createVNode(_component_ErrorMessage, { name: "otraArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.areaDentroDeLaEmpresa?.id === 'Otra (por favor, especifique)']
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createVNode(_component_Field, {
                  name: "rolCargo",
                  modelValue: _ctx.formData.rolCargo,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.rolCargo) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      panelStyle: { width: '50%' },
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.rolesCargo,
                      optionLabel: "descripcion"
                    }, {
                      option: _withCtx((slotProps) => [
                        _createElementVNode("div", _hoisted_79, [
                          _createElementVNode("div", null, _toDisplayString(slotProps.option.descripcion), 1),
                          _createElementVNode("div", _hoisted_80, _toDisplayString(slotProps.option.detalle), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_81, [
                      _createVNode(_component_ErrorMessage, { name: "rolCargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_82, [
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createVNode(_component_Field, {
                  name: "otroCargo",
                  modelValue: _ctx.formData.otroCargo,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.otroCargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: "Otra cargo",
                      class: ["w-full p-inputtext-sm p-3 text-sm rounded-lg border", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]
                    }), null, 16, ["class"]),
                    _createElementVNode("span", _hoisted_85, [
                      _createVNode(_component_ErrorMessage, { name: "otroCargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ], 512), [
              [_vShow, _ctx.formData.rolCargo?.id === 'Otros']
            ]),
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("div", _hoisted_87, [
                _hoisted_88,
                _createVNode(_component_Field, {
                  name: "rolCompra",
                  modelValue: _ctx.formData.rolCompra,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.rolCompra) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value , errors}) => [
                    _createVNode(_component_Dropdown, {
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      placeholder: "Seleccione una opción",
                      class: _normalizeClass(["w-full p-inputtext-sm", { 'bg-gray-50': errors.length === 0, 'bg-green-50 border border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && value !== undefined, 'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0}]),
                      options: _ctx.rolesCompra,
                      optionLabel: "descripcion"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                    _createElementVNode("span", _hoisted_89, [
                      _createVNode(_component_ErrorMessage, { name: "rolCompra" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "aggrement",
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.terminosCondiciones) = $event)),
                    class: "text-primary focus:ring-0 rounded-sm cursor-pointer"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.formData.terminosCondiciones]
                  ]),
                  _hoisted_93
                ])
              ]),
              _hoisted_94
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-2 px-4 py-2 bg-transparent border-blue-950 hover:bg-black text-blue-950 font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_97, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_98, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode("REGISTRARME ")
              ], 8, _hoisted_96)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}